module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('f7-navbar', {
    staticClass: "navbar-container"
  }, [_c('f7-nav-left', {
    staticClass: "navbar_right",
    style: ({
      'background-color': _vm.customization.mainColor
    })
  }, [_c('a', {
    staticClass: "open-panel",
    attrs: {
      "href": "#",
      "data-panel": "left"
    },
    on: {
      "click": _vm.onMenuRight
    }
  }, [_c('div', {
    staticClass: "navbar_right"
  }, [_c('span', {
    staticClass: "icon-customer-app icon-menu",
    staticStyle: {
      "padding": "17.5px 0px 0px",
      "display": "block",
      "color": "rgb(215, 25, 33)",
      "font-size": "24px"
    },
    style: ({
      color: _vm.customization.iconColor
    })
  })])])]), _vm._v(" "), _c('f7-nav-center', {
    staticClass: "navbar-center"
  }, [_c('div', {
    staticClass: "logo_text"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [(_vm.isLogoShowed) ? _c('img', {
    attrs: {
      "src": _vm.logo
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLogoShowed) ? _c('div', {
    staticClass: "salesperson-name",
    on: {
      "click": function($event) {
        return _vm.redirectToSiteUrl('home')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#7F7F7F"
    }
  }, [_vm._v(_vm._s(_vm.SalesPersonFirst))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.SalesPersonLast))])]) : _vm._e()])])]), _vm._v(" "), _c('f7-nav-right', [_c('a', {
    staticClass: "open-panel",
    attrs: {
      "href": "#",
      "data-panel": "right"
    },
    on: {
      "click": _vm.onMenuLeft
    }
  }, [_c('div', {
    staticClass: "navbar_right graybg"
  }, [(!_vm.customerUser.profilePhoto) ? _c('img', {
    attrs: {
      "src": "/static/images/icons/black/user.png",
      "alt": "",
      "title": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.customerUser.profilePhoto) ? _c('img', {
    staticClass: "navbar-avatar",
    attrs: {
      "src": _vm.customerUser.profilePhoto,
      "alt": "",
      "title": ""
    }
  }) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-overlay nav-position-fixed",
    on: {
      "click": _vm.clearMargin
    }
  }), _vm._v(" "), _c('f7-panel', {
    staticClass: "nav-position-fixed right_nav",
    style: ({
      'background-color': _vm.customization.mainColor
    }),
    attrs: {
      "right": "",
      "cover": "",
      "layout": "light"
    }
  }, [_c('div', {
    staticClass: "rightContainer"
  }, [_c('div', {
    staticClass: "user_login_info"
  }, [_c('div', {
    staticClass: "user_thumb"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl,
      "alt": "",
      "title": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user_details"
  }, [_c('p', {
    style: ({
      color: _vm.customization.fontColor
    })
  }, [_vm._v("\n              Welcome,\n              "), _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.customerUser.firstName + " " + _vm.customerUser.lastName))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.customerUser.isDemoUser ? '#' : 'edit-user-profile/'
    }
  }, [_c('div', {
    staticClass: "user_avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.customerUser.profilePhoto ?
        _vm.customerUser.profilePhoto :
        '/static/images/avatar.jpg',
      "alt": "",
      "title": ""
    }
  })])])]), _vm._v(" "), _c('nav', {
    staticClass: "user-nav"
  }, [_c('ul', [_c('li', {
    style: ({
      'border-bottom-color': _vm.customization.iconColor
    })
  }, [_c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": _vm.customerUser.isDemoUser ? '#' : 'edit-user-profile'
    },
    on: {
      "click": _vm.clearMargin
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-user-circle",
    style: ({
      color: _vm.customization.iconColor
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "right-nav-span",
    style: ({
      color: _vm.customization.fontColor,
      'font-size': '16px',
    })
  }, [_vm._v("My Profile")])])]), _vm._v(" "), (_vm.videoMessageCount != 0) ? _c('li', {
    style: ({
      'border-bottom-color': _vm.customization.iconColor
    })
  }, [_c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": "video-message"
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-video",
    style: ({
      color: _vm.customization.iconColor
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "right-nav-span",
    style: ({
      color: _vm.customization.fontColor,
      'font-size': '16px',
    })
  }, [_vm._v("Video Messages")])]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    style: ({
      color: _vm.customization.mainColor,
      'background-color': _vm.customization.iconColor,
    })
  }, [_vm._v(_vm._s(_vm.videoMessageCount))])]) : _vm._e(), _vm._v(" "), (_vm.slsPermission.recommendAFriend) ? _c('li', {
    style: ({
      'border-bottom-color': _vm.customization.iconColor
    })
  }, [_c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": "recommendfriend"
    },
    on: {
      "click": function($event) {
        return _vm.setPageShare(_vm.SharepageEnum.history)
      }
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-users-three",
    style: ({
      color: _vm.customization.iconColor
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "right-nav-span",
    style: ({
      color: _vm.customization.fontColor,
      'font-size': '16px',
    })
  }, [_vm._v("Refer")])]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    style: ({
      color: _vm.customization.mainColor,
      'background-color': _vm.customization.iconColor,
    })
  }, [_vm._v(_vm._s(_vm.referralsCount))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "termContainer",
    staticStyle: {
      "padding-left": "9%"
    }
  }, [_c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": "terms"
    }
  }, [_vm._v(" Terms and Conditions ")]), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.customization.fontColor
    })
  }, [_vm._v("and")]), _vm._v(" "), _c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": "policy"
    }
  }, [_vm._v(" Privacy Policy ")])])])]), _vm._v(" "), _c('f7-panel', {
    staticClass: "nav-position-fixed left_nav",
    style: ({
      'background-color': _vm.customization.mainColor
    }),
    attrs: {
      "left": "",
      "cover": "",
      "layout": "light"
    }
  }, [_c('nav', {
    staticClass: "icons_31",
    class: _vm.customization.navMenuId === 1 ? 'sidebar-nav' : 'main-nav'
  }, [(_vm.customization.navMenuId === 1) ? _c('list-menu-component', {
    attrs: {
      "items": _vm.customButtons,
      "fontColor": _vm.customization.fontColor,
      "iconColor": _vm.customization.iconColor
    },
    on: {
      "onClick": function($event) {
        return _vm.OnItemClick($event)
      }
    }
  }) : _c('grid-menu-component', {
    attrs: {
      "items": _vm.customButtons,
      "fontColor": _vm.customization.fontColor,
      "iconColor": _vm.customization.iconColor
    },
    on: {
      "onClick": function($event) {
        return _vm.OnItemClick($event)
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4767b395", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4767b395"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/navbar.vue
// module id = 774
// module chunks = 0